"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Flex = _interopRequireDefault(require("./Flex.js"));
var _RowModule = _interopRequireDefault(require("./Row.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Row component
 *
 * A borderless card.
 */class Row extends _react.default.PureComponent {
  /**
   * Render.
   * 
   * @return {ReactNode}
   */
  render() {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Flex.default, {
      className: `${this.props.className || ""} ${_RowModule.default.root}`.trim(),
      columns: this.props.columns,
      columnar: true,
      fullWidth: true,
      gridAutoColumns: "1fr",
      rootRef: this.props.rootRef,
      children: this.props.children
    });
  }
}
var _default = exports.default = Row;